import React, { useEffect, useState } from 'react'
import data from '../../PatientExperience.json'
import { CardWithImage } from '../Programs/OutComesSection';
const { healthPrograms } = data.sections;
const ReviewCards = () => {
    const { id, heading, learnMore, items } = healthPrograms;
    const [startIndex, setStartIndex] = useState(0);
    const [visibleCount, setVisibleCount] = useState(1);
    useEffect(() => {
        const updateCount = () => {
            const width = window.innerWidth;
            if (width >= 1024) setVisibleCount(3);
            else if (width >= 640) setVisibleCount(2);
            else setVisibleCount(1);
        }
        updateCount();
        window.addEventListener("resize", updateCount);
        return (() => window.removeEventListener("resize", updateCount));
    }, [])
    const hasMore = items.length > visibleCount;
    const maxStart = Math.max(0, items.length - visibleCount);
    const canPrev = startIndex > 0;
    const canNext = startIndex < maxStart;
    useEffect(() => {
        setStartIndex((i) => Math.min(i, Math.max(0, items.length - visibleCount)));
    }, [visibleCount, items.length]);
    const visibleItems = items.slice(startIndex, startIndex + visibleCount);
    const handlePrev = () => {
        if (canPrev) setStartIndex((i) => i - 1)
    }
    const handleNext = () => {
        if (canNext) setStartIndex((i) => i + 1)
    }

    return (
        <section id={id} className="w-full bg-white py-4 md:py-8 ">
            <div className="container mx-auto px-4 md:px-8 bg-[var(--light-gray)]  rounded-3xl shadow-sm p-4 md:p-6">
                {/* ── Header row ── */}
                <div className="flex  mb-6 md:mb-8 items-center justify-center text-center">
                    <h2
                        className="font-bold leading-snug primary-text text-center text-xl uppercase"
                    >
                        {heading}
                    </h2>
                </div>
                {/* ── Cards + Arrows ── */}
                <div className="relative">
                    {/* Cards grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 ">
                        {visibleItems.map((item) => (
                            <ReviewCard key={item.id} item={item}  />
                        ))}
                    </div>
                    {/* ── Left Arrow ── */}
                    {hasMore && (
                        <button
                            onClick={handlePrev}
                            disabled={!canPrev}
                            aria-label="Previous programs"
                            className="flex absolute -left-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white border transition-all duration-200"
                            style={{
                                borderColor: "var(--gray-300)",
                                boxShadow: "0 2px 12px rgba(0,36,107,0.12)",
                                opacity: canPrev ? 1 : 0.35,
                                cursor: canPrev ? "pointer" : "not-allowed",
                            }}
                        >
                            {/* <img
                                src="/images/left-arrow.svg"
                                alt="Previous"
                                className="w-10 h-10"
                            /> */}
                              <svg className="w-4 h-4 primary-text " fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
                        </button>
                    )}

                    {/* ── Right Arrow ── */}
                    {hasMore && (
                        <button
                            onClick={handleNext}
                            disabled={!canNext}
                            aria-label="Next programs"
                            className="flex absolute -right-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white border transition-all duration-200"
                            style={{
                                borderColor: "var(--gray-300)",
                                boxShadow: "0 2px 12px rgba(0,36,107,0.12)",
                                opacity: canNext ? 1 : 0.35,
                                cursor: canNext ? "pointer" : "not-allowed",
                            }}
                        >
                            {/* <img
                                src="/images/right-arrow.svg"
                                alt="Next"
                                className="w-10 h-10"
                            /> */}
                            <svg className="w-4 h-4 primary-text" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
                        </button>
                    )}
                </div>

            </div>
        </section>
    )
}

export default ReviewCards

const ReviewCard = ({ item }) => {
  return (
    <div className="flex items-start gap-3 rounded-2xl w-full bg-white p-4 justify-center items-center" style={{ boxShadow: "0 0 12px rgba(0,0,0,0.12)" }} >
      
      {/* Avatar */}
      <div className="h-20 w-20 shrink-0">
        <img
          src={item.image}
          alt={item.reviewerName}
          className="h-full w-full object-cover rounded-full"
        />
      </div>

      {/* Text block */}
      <div className="flex flex-col pl-2">
        
        {/* Description */}
        <p className="text-sm  leading-relaxed primary-text mb-1">
          “{item.description}”
        </p>

        {/* Name */}
        <h3 className="text-[13px] font-semibold ">
          - {item.reviewerName}
        </h3>

        {/* Program */}
        <p className="text-sm  font-semibold primary-text">
          {item.program}
        </p>
      </div>
    </div>
  );
};

//   return (
//     <div className="flex flex-row items-center text-center rounded-2xl w-full bg-white border border-red-500 p-4">
      
//       {/* Avatar */}
//       <div className="h-16 w-16 mb-3">
//         <img
//           src={item.image}
//           alt={item.title}
//           className="h-full w-full object-cover rounded-full"
//         />
//       </div>

//       {/* Content */}
//       <div className="w-full">
//         <h3 className="mb-2 text-sm font-medium primary-text">
//           {item.title}
//         </h3>

//         {item?.desc && (
//           <p className="text-xs leading-relaxed primary-text">
//             {item.desc}
//           </p>
//         )}
//       </div>
//     </div>
//   );
// };